module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.1b938005.ttf";